import { createGlobalStyle } from 'styled-components';

const basicStyle = `
  body {
    font-family: "Montserrat", sans-serif;
    height: 100%;
    background-color: #F3F5F9;
    letter-spacing: -0.24px;
    line-height: 1.6;
    font-size: 17px;

    * {
      box-sizing: border-box;
    }

    p {
      font-size: 13px;
      line-height: 1.6;
    }

    a {
      color: #1D78ED;
      text-decoration: none;
    }
  }
  #root {
    min-height: 100vh;
    display: flex;
    flex-flow: column;
    & > div {
      flex: 1;
    }
  }
  img {
    max-width: 100%;
  }
  h1 {
    font-weight: bold;
    margin-bottom: 0;
    font-size: 34px;
  }

  h2 {
    font-weight: bold;
    margin-bottom: 0;
  }

  h3 {
    font-size: 22px;
    line-height: 1.6;
    font-weight: bold;
    margin-bottom: 0;
    margin-top: 0;
  }

  h4 {
    font-size: 20px;
    letter-spacing: -0.38px;
    font-weight: bold;
    margin: 0;
  }

  h5 {
    font-size: 15px;
    letter-spacing: -0.24px;
    font-weight: 600;
    margin: 0;
  }
  h6 {
    font-size: 13px;
    font-weigth: bold;
    margin: 0;
  }

  hr {
    border-top: 0;
    border-color: #C4C4C4;
    opacity: 0.21;
  }

  .text-center {
    text-align: center;
  }
  .text-left {
    text-align: left;
  }
  .text-right {
    text-align: right;
  }
  .w-full {
    width: 100%;
  }

  .uppercase {
    text-transform: uppercase;
  }

  .text {
    &--nowrap {
      white-space: nowrap;
    }
    &--primary {
      color: #363895;
    }
    &--secondary {
      color: #FFBB10;
    }
    &--black {
      color: #344356;
    }
    &--danger {
      color: #ff6357;
    }
    &--grey {
      opacity: 0.8;
    }
    &--tight {
      letter-spacing: -0.41px;
    }

    &--disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }

    &--semibold {
      font-weight: 600;
    }
    &--bold {
      font-weight: 700;
    }
    &--normal {
      font-weight: normal;
    }

    &--size-17 {
      font-size: 17px;
    }
    &--size-15 {
      font-size: 15px;
    }
    &--size-13 {
      font-size: 13px;
    }
  }

  button, input, textarea {
    outline: none !important;
  }


  .flex {
    display: flex;
    &--row {
      flex-flow: row;
    }
    &--column {
      flex-flow: column;
    }

    &--1 {
      flex: 1;
      min-height: 0;
    }

    &--auto {
      flex: auto;
    }

    &--wrap {
      flex-wrap: wrap;
    }
    &--no-wrap {
      flex-wrap: no-wrap;
    }
  }

  .justify-content {
    &-start {
      justify-content: flex-start;
    }
    &-end {
      justify-content: flex-end;
    }
    &-center {
      justify-content: center;
    }
    &-space-around {
      justify-content: space-around;
    }
    &-space-between {
      justify-content: space-between;
    }
  }

  .align-items {
    &-start {
      align-items: flex-start;
    }
    &-end {
      align-items: flex-end;
    }
    &-center {
      align-items: center;
    }
  }

  .switch-wrapper {
    position: relative;
  }

  .switch-wrapper > div {
    position: absolute;
    width: 100%;
    height: 100%;
  }

`;

const directions = {
  t: 'top',
  b: 'bottom',
  l: 'left',
  r: 'right',
};

const spacingTypes = {
  p: 'padding',
  m: 'margin',
};
const arr = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15];
const paddingStyle = arr.map(item => {
  let output = '';
  Object.keys(spacingTypes).forEach(spacingType => {
    Object.keys(directions).forEach(dKey => {
      output += `
        .${spacingType}${dKey}-${item} {
          ${spacingTypes[spacingType]}-${directions[dKey]}: ${5 * item}px;
        }
      `;
    });
  });

  return output;
});

export default createGlobalStyle`
  ${basicStyle}
  ${paddingStyle.join(' ')}
`;
